import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ResponsiveFormHost } from "../components/shared/ResponsiveFormHost";
import { GroupForm } from "../components/participants/GroupForm";
import { NotFoundPage } from "./NotFoundPage";
import { useEvents } from "../context/EventContext";

export function CreateGroupPage() {
  const { eventId } = useParams<{ eventId: string }>();
  const navigate = useNavigate();
  const {
    setCurrentEventId,
    currentEvent,
    isLoading,
    events,
    createGroup,
  } = useEvents();

  useEffect(() => {
    if (eventId) {
      setCurrentEventId(eventId);
    }
    return () => setCurrentEventId(null);
  }, [eventId, setCurrentEventId]);

  const parentRoute = `/event/${eventId}/participants`;

  const handleSubmit = (
    name: string,
    participantIds: string[],
    representativeId: string
  ) => {
    createGroup(name, participantIds, representativeId);
    navigate(parentRoute);
  };

  const handleCancel = () => {
    navigate(parentRoute);
  };

  // Show 404 if event not found (after loading)
  if (!isLoading && eventId && !events.find((e) => e.id === eventId)) {
    return <NotFoundPage />;
  }

  if (isLoading || !currentEvent) {
    return null;
  }

  const unassignedParticipants = currentEvent.participants.filter(
    (p) => !p.groupId
  );

  return (
    <ResponsiveFormHost title="Nuevo grupo" parentRoute={parentRoute}>
      <GroupForm
        availableParticipants={unassignedParticipants}
        onSubmit={handleSubmit}
        onCancel={handleCancel}
      />
    </ResponsiveFormHost>
  );
}
